
  <div class="sidebar" data-color="rose" data-background-color="red" data-image="./assets/img/sidebar-1.jpg">
    <div class="logo">
      <a class="simple-text logo-mini">
        <div class="logo-img">
          <img src="/assets/img/angular2-logo-white.png" />
        </div>
      </a>
      <a href="https://www.creative-tim.com" class="simple-text logo-normal">
        Creative Tim
      </a>
    </div>


    <div class="sidebar-wrapper">

      <div *ngIf="isMobileMenu()">
        <form class="navbar-form">
          <span class="bmd-form-group">
            <div class="input-group no-border">
              <input type="text" value="" class="form-control" placeholder="Search...">
              <button mat-raised-button type="submit" class="btn btn-white btn-round btn-just-icon">
                <i class="material-icons">search</i>
                <div class="ripple-container"></div>
              </button>
            </div>
          </span>
        </form>
        <ul class="nav navbar-nav nav-mobile-menu">
          <li class="nav-item">
            <a class="nav-link" href="#pablo">
              <i class="material-icons">dashboard</i>
              <p>
                <span class="d-lg-none d-md-block">Stats</span>
              </p>
            </a>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link" href="#pablo" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="material-icons">notifications</i>
              <span class="notification">5</span>
              <p>
                <span class="d-lg-none d-md-block">Some Actions</span>
              </p>
            </a>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
              <a class="dropdown-item" href="#">Mike John responded to your email</a>
              <a class="dropdown-item" href="#">You have 5 new tasks</a>
              <a class="dropdown-item" href="#">You're now friend with Andrew</a>
              <a class="dropdown-item" href="#">Another Notification</a>
              <a class="dropdown-item" href="#">Another One</a>
            </div>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#pablo">
              <i class="material-icons">person</i>
              <p>
                <span class="d-lg-none d-md-block">Account</span>
              </p>
            </a>
          </li>
        </ul>
      </div>
      <ul class="nav" >
        <li routerLinkActive="active" *ngFor="let menuitem of menuItems" class="nav-item" >
          <!--If is a single link-->
          <a [routerLink]="[menuitem.path]" *ngIf="menuitem.type === 'link'" class="nav-link">
            <i class="material-icons">{{menuitem.icontype}}</i>
            <p>{{menuitem.title}}</p>
          </a>
          <!--If it have a submenu-->
          <a data-toggle="collapse" href="#{{menuitem.collapse}}" *ngIf="menuitem.type === 'sub'" (click)="updatePS()" class="nav-link">
            <i class="material-icons">{{menuitem.icontype}}</i>
            <p>{{menuitem.title}}<b class="caret"></b></p>
          </a>

          <!--Display the submenu items-->
          <div id="{{menuitem.collapse}}" class="collapse" *ngIf="menuitem.type === 'sub'">
            <ul class="nav">
              <li routerLinkActive="active" *ngFor="let childitem of menuitem.children" class="nav-item">
                <a [routerLink]="[menuitem.path, childitem.path]" class="nav-link">
                  <span class="sidebar-mini">{{childitem.ab}}</span>
                  <span class="sidebar-normal">{{childitem.title}}</span>
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ul>

    </div>
    <div class="sidebar-background" style="background-image: url(assets/img/sidebar-1.jpg)"></div>
  </div>
  <div class="main-panel">
    <nav #navbar class="navbar navbar-expand-lg navbar-transparent  navbar-absolute">
      <div class="container-fluid">
        <div class="navbar-wrapper">
          <div class="navbar-minimize">
            <button mat-raised-button (click)="minimizeSidebar()" class="btn btn-just-icon btn-white btn-fab btn-round">
              <i class="material-icons text_align-center visible-on-sidebar-regular">more_vert</i>
              <i class="material-icons design_bullet-list-67 visible-on-sidebar-mini">view_list</i>
            </button>
          </div>
        </div>
        <button mat-button class="navbar-toggler btn-no-ripple" type="button" (click)="sidebarToggle()">
          <span class="sr-only">Toggle navigation</span>
          <span class="navbar-toggler-icon icon-bar"></span>
          <span class="navbar-toggler-icon icon-bar"></span>
          <span class="navbar-toggler-icon icon-bar"></span>
        </button>
        <div class="collapse navbar-collapse justify-content-end" id="navigation">
          <ul class="navbar-nav">
            <li class="nav-item dropdown">
              <a class="nav-link" href="#pablo" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="material-icons">notifications</i>
                <span class="notification">5</span>
                <p>
                  <span class="d-lg-none d-md-block">Some Actions</span>
                </p>
              </a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
                <a class="dropdown-item" href="#">Mike John responded to your email</a>
                <a class="dropdown-item" href="#">You have 5 new tasks</a>
                <a class="dropdown-item" href="#">You're now friend with Andrew</a>
                <a class="dropdown-item" href="#">Another Notification</a>
                <a class="dropdown-item" href="#">Another One</a>
              </div>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#pablo">
                <i class="material-icons">person</i>
                <p>
                  <span class="d-lg-none d-md-block">Account</span>
                </p>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    </div>
